module.exports = __webpack_public_path__ + "img/facebook-c.196f268.png";